/* unplugin-vue-components disabled */import { render } from "./ai-suggestion.vue?vue&type=template&id=58cb1d76&scoped=true"
import script from "./ai-suggestion.vue?vue&type=script&lang=js"
export * from "./ai-suggestion.vue?vue&type=script&lang=js"

import "./ai-suggestion.vue?vue&type=style&index=0&id=58cb1d76&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58cb1d76"],['__file',"src/components/ai-chat-v2/ai-suggestion.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "58cb1d76"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('58cb1d76', __exports__)) {
    api.reload('58cb1d76', __exports__)
  }
  
  module.hot.accept("./ai-suggestion.vue?vue&type=template&id=58cb1d76&scoped=true", () => {
    api.rerender('58cb1d76', render)
  })

}


export default __exports__